import { render } from "./turnos.vue?vue&type=template&id=4c052c46&scoped=true"
import script from "./turnos.vue?vue&type=script&lang=js"
export * from "./turnos.vue?vue&type=script&lang=js"

import "./turnos.vue?vue&type=style&index=0&id=4c052c46&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\easyturno\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c052c46"]])

export default __exports__